/**
 * Information about value requirements for an action/configuration values
 * The name top level properties here refer to the action/config name
 * The selected value information is only stored in valueElementToReferenceId & valueElementToReferenceDeveloperName
 * @typedef {Object} ServiceValue
 * @property {string} contentType - the contentType restriction of this config setting
 * @property {string} developerName - the name of this configuration setting
 * @property {number} order - the order of this setting to be shown in
 * @property {?string} typeElementDeveloperName - the name of the Type restriction of this config setting
 * @property {?string} typeElementId - the id of the Type restriction of this config value
 * @property {?string} valueElementToReferenceDeveloperName - the name of the selected value for this config setting
 * @property {?BasicValueReference} valueElementToReferenceId - the ids of the selected value for this config setting
 * 
 * Simple reference to a value that just stores id information
 * @typedef {object} BasicValueReference
 * @property {?string} command - not used
 * @property {string} id - the id of the value to be referenced
 * @property {?string} typeElementPropertyId - the property id of the value to be referenced
 * 
 * Stores information about any value reference
 * Has all information from the /reference endpoint
 * @typedef {object} FullValueReference
 * @property {string} access - access of the value e.g. PRIVATE
 * @property {?string} command - not used
 * @property {string} contentType - contentType of the value/property e.g. ContentObject
 * @property {string} developerName - name of the value e.g. !Grab single
 * @property {string} elementType - type of shared element (always VARIABLE for this data)
 * @property {string} id - id of the value
 * @property {string} isFixed - if this value is set to be versionless or not
 * @property {?string} parentContentType - if contentType is being for the property contentType,
 *                                         this will value contentType e.g. List/Object 
 * @property {?string} serviceElementDeveloperName - name of the service the value comes from
 * @property {?string} serviceElementId - id of the service the value comes from
 * @property {?string} typeElementDeveloperName - name of the type this value is using
 * @property {?string} typeElementId - id of the type this value is using
 * @property {?string} typeElementPropertyDeveloperName - name of the property this reference is using
 * @property {?string} typeElementPropertyId - id of the property this reference is using
 * @property {?string} typeElementPropertyTypeElementDeveloperName - name of the type this property is using
 * @property {?string} typeElementPropertyTypeElementId - id of the type this property is using
 * 
 * Stores the information about the selected value reference
 * Converted from the FullValueReference, to the appropriate form for the Value Selector
 * @typedef {object} ValueSelectorMetadata
 * @property {string} contentType - contentType of the value/property e.g. ContentObject
 * @property {string} developerName - name of the value e.g. !Grab single
 * @property {string} elementMeta - full textual description of value reference
 *                                  e.g. "↵    Object of ↵    Account↵     from  Tom Salesforce↵     / ↵    Number↵    "
 * @property {string} elementName - one line description of value reference e.g. "!Grab single / Employees"
 * @property {string} id - id of the value
 * @property {?string} parentContentType - if contentType is being for the property contentType,
 *                                         this will value contentType e.g. List/Object 
 * @property {?string} propertyId - id of the property this reference is using
 */
